// extracted by mini-css-extract-plugin
export var circle = "image-module--circle--784bd";
export var image = "image-module--image--d06e5";
export var wrapper = "image-module--wrapper--13e0f";